'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import QuizArenaContent from './components/QuizArenaContent';

export default function QuizArenaPage() {
  return (
    <AppLayout activePath="/quiz-arena">
      <QuizArenaContent />
    </AppLayout>
  );
}
